import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { GrupoClassificacao } from '../../grupo-classificacao';

@Injectable({
    providedIn: 'root'
})
export class GrupoClassificacaoSituacaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/grupoclassificacao`;
    }

    /** Carrega o grupo de classificação de Cadastro de Clientes */
    loadCadastroCliente(): Observable<GrupoClassificacao> {
        return this.customHttp.get<GrupoClassificacao>(`${this.pathApi}/0/situacao/cadastrocliente`);
    }

    /** Carrega o grupo de classificação de Cadastro de Itens */
    loadCadastroItem(): Observable<GrupoClassificacao> {
        return this.customHttp.get<GrupoClassificacao>(`${this.pathApi}/0/situacao/cadastroitem`);
    }
}
